import { AssetSearch } from "~/v3-poc/features/asset-search/AssetSearch.connector";
import type { AtdTheme } from "~/v3-poc/features/user-preferences";
import { usePortfolioHistoryChartController } from "./PortfolioHistoryChart.controller";
import { PortfolioHistoryChartPresentation } from "./PortfolioHistoryChart.pres";
import { usePortfolioHistoryChartLifecycleController } from "./PortfolioHistoryChartLifecycle.controller";

interface PortfolioHistoryChartProps {
  id: string;
  theme: AtdTheme;
}

export const PortfolioHistoryChart = ({
  id,
  theme,
}: PortfolioHistoryChartProps) => {
  const {
    comparisonSearchValue,
    comparisons,
    data,
    hasError,
    isComparisonFetching,
    isLoading,
    isPortfolioFetching,
    lookback,
    onComparisonSearchValueChange,
    onComparisonSelect,
    onLookbackChange,
    onRefresh,
    onRemoveComparison,
    percentageData,
    shouldRenderChart,
  } = usePortfolioHistoryChartController({ id });
  const { chartContainerRef } = usePortfolioHistoryChartLifecycleController({
    comparisons,
    data,
    isComparisonFetching,
    isPortfolioFetching,
    lookback,
    percentageData,
    shouldRenderChart,
    theme,
  });
  const comparisonSearch = (
    <AssetSearch
      placeholder="Compare symbol..."
      showFilters={false}
      value={comparisonSearchValue}
      onChange={onComparisonSearchValueChange}
      onSelect={onComparisonSelect}
    />
  );

  return (
    <PortfolioHistoryChartPresentation
      chartContainerRef={chartContainerRef}
      comparisons={comparisons}
      comparisonSearch={comparisonSearch}
      data={data}
      hasError={hasError}
      isLoading={isLoading}
      isPortfolioFetching={isPortfolioFetching}
      lookback={lookback}
      onRemoveComparison={onRemoveComparison}
      onLookbackChange={onLookbackChange}
      onRefresh={onRefresh}
      shouldRenderChart={shouldRenderChart}
    />
  );
};
